import React from "react";
import { useTranslation } from "react-i18next";
import { LanguageSelection } from "../LanguageSelection/LanguageSelection";
import { NavigationLink } from "../NavigationLink/NavigationLink";
import { PageSelection } from "../PageSelection/PageSelection";
import { SolutionPageSelection } from "../SolutionPageSelection/SolutionPageSelection";
import { ResourcePageSelection } from "../ResourcePageSelection/ResourcePageSelection";
import { DemoModalButton } from "../ModalButtons/DemoModalButton";
import { TrialModalButton } from "../ModalButtons/TrialModalButton";
import { getImage } from "../../services/ImageService";

export function Navbar() {
    const { t } = useTranslation();

    return (
        <div className="flex bg-[#368E66] h-24 fixed w-full z-50 2xl:justify-center">
            <div className="h-full flex relative w-full 2xl:max-w-screen-lg justify-start lg:justify-between md:px-28 2xl:p-0">
                <PageSelection />
                <div className="hidden xl:flex h-full">
                    <NavigationLink
                        content={
                            <img
                                src={getImage("gf_logo_white_compact")}
                                className="h-full w-full"
                            ></img>
                        }
                        target=""
                        className="w-40 mr-8"
                    />
                    <SolutionPageSelection />
                    <ResourcePageSelection />
                </div>
                <div className="w-full bg-[#368E66] h-full z-20"></div>
                <DemoModalButton className="hidden mr-10 lg:flex" />
                <TrialModalButton className="hidden mr-12 lg:flex" />
                <LanguageSelection />
            </div>
        </div>
    );
}
